module.exports = __webpack_public_path__ + "img/sld_scb_28_t1_b1_green.5ff7e43b.svg";